<template>
  <v-container fluid pa-0>
    <v-row row wrap>
      <v-col cols="12">
        <v-data-table :headers="headers" :items="items">
          <template v-slot:item.availability="{item}">
            <v-tooltip top v-if="item.product">
              <template #activator="{ on }">
                <v-chip :color="item.product.on_hand >= item.quantity-item.already_picked ? ' green':'red'" v-on="on">
                  {{item.product.on_hand >= item.quantity-item.already_picked ? ' Available':'Not Available'}}
                </v-chip>
              </template>
              <div>
                On hand : {{item.product.on_hand}}<br>
                Pending : {{item.product.pending}}<br>
                <hr>
                <b>Available : {{item.product.available}}</b><br>
                Incoming : {{item.product.incoming}}<br>
              </div>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

export default {
  props: {
    items: {
      type: Array
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    headers: {
      type: Array,
      default: () => [
        { text: "Type", value: "typeId", align: "left" },
        { text: "Description", value: "product.name", align: "left" },
        { text: "Qty", value: "quantity", align: "left" },
        { text: "Picked", value: "already_picked", align: "left" },
        { text: "Availability", value: "availability", align: "left" },
      ]
    }
  },
  data() {
    return {
      search: "",
      pagination: { rowsPerPage: 20 },
      formOpen: false,
      discountItem: null,
      discountForm: false
    };
  },
  mounted() {
  },
  methods: {
  }
};
</script>

<style lang="less" scoped>
.nowrap {
  white-space: nowrap;
}
</style>
